/**
 * Copyright © 2025 650 Industries.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ServerDataLoaderContext", {
    enumerable: true,
    get: function() {
        return ServerDataLoaderContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const ServerDataLoaderContext = (0, _react().createContext)(null);

//# sourceMappingURL=ServerDataLoaderContext.js.map
